"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeSelector = exports.brands = void 0;

var react_1 = __importDefault(require("react"));

var brands_1 = __importDefault(require("./brands"));

var classnames_1 = __importDefault(require("classnames"));

var SzSelect_1 = require("../components/SzSelect/SzSelect");

exports.brands = Object.keys(brands_1.default);

exports.ThemeSelector = function (_a) {
  var className = _a.className,
      props = __rest(_a, ["className"]);

  var options = exports.brands.map(function (label, value) {
    return {
      value: value.toString(),
      label: label
    };
  });
  var classes = classnames_1.default('theme-selector', className);
  return react_1.default.createElement("div", {
    className: classes
  }, react_1.default.createElement(SzSelect_1.SzSelect, __assign({
    name: "theme-selector",
    placeholder: "Changer de th\xE8me",
    options: options,
    isSearchable: true
  }, props)));
};